import { STAFF_SUPPORT_EMAIL } from "../../../utils/userFacingError";

/**
 * Hover text for Download > Sage Accounting / QuickBooks on Reports and in
 * the report preview (wave 3). "Earlier dates" restates the backend rule that
 * the export includes receivables carried forward from earlier periods.
 */
export const ACCOUNTING_EXPORT_AVAILABLE_HOVER_TEXT =
  "Download the invoices in this report for your accounting software. Invoices from earlier dates that still have a balance owing are included.";

/** `organizationNoun` is the chamber noun, for example "chamber" or "board". */
export const getAccountingExportOffHoverText = (organizationNoun: string) =>
  `Sage Accounting and QuickBooks downloads are not turned on for your ${organizationNoun}. To turn them on, email ${STAFF_SUPPORT_EMAIL}.`;
